import { KEYS } from 'app/constants/SceneConstants';
import SceneBaseTT from './SceneBaseTT';

export default class GameOver extends SceneBaseTT {
  constructor() {
    super({ key: KEYS.GameOver, active: false });
  }

  init(config) {
    this._config = config.data;
  }

  create() {
    super.create();
    this.setBackgroundImage('overlay_purple');
    this.game.hud.setState('GAME_OVER');
    this.add.image(840, 360, 'graphics', 'overlay_panel_yellow'),
      this.add.image(840, 235, 'locale_text', 'title_gameover'),
      this.add
        .image(590, 720, 'character_thumbs', 'char_pose_' + this._config.heroid + '_fail')
        .setOrigin(1);

    this.game.soundController.playSFX('sfx', 'arrive _Level_fail_screen');
    this.game.soundController.playMusic('killed');
  }

  shutdown() {
    this.game.hud.resumePreviousState();
    super.shutdown();
  }
}
